import axios from 'axios'

let headers = {
  'Content-Type': 'application/json'
}

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers
})

instance.interceptors.request.use(function(config) {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export const defaultError = {
  code: 500,
  status: 'error',
  message: 'Terjadi Kesalahan. Hubungi Developer.'
}

instance.interceptors.response.use(
  function(response) {
    return response
  },
  function(err) {
    if (err.response && err.response.data) {
      if (err.response.status === 401 && location.pathname != '/login') {
        localStorage.removeItem('access_token')
        location.replace('/login')
      }
      return Promise.reject(err.response)
    }
    return Promise.reject(defaultError)
  }
)

export default instance
